import { CanActivateFn } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { filter, map, switchMap, take } from 'rxjs/operators';

const ROLES_CLAIM = 'https://docuty.com/roles';
const SYSTEM_ADMIN_ROLE = 'SystemAdmin';

/**
 * Guards routes that require the Auth0 "SystemAdmin" role.
 *
 * The role is read from a custom claim injected by a Post-Login Action.
 *
 * Unauthenticated users are redirected to /login.
 * Authenticated users without the role are also redirected to /login.
 */
export const systemAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.isLoading$.pipe(
    filter(loading => !loading),
    take(1),
    switchMap(() => auth.user$),
    take(1),
    map(user => {
      if (!user) {
        return router.createUrlTree(['/login']);
      }

      const roles: string[] = user[ROLES_CLAIM] ?? [];
      if (!roles.includes(SYSTEM_ADMIN_ROLE)) {
        return router.createUrlTree(['/login']);
      }

      return true;
    })
  );
};
